import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';
import { jwtDecode } from "jwt-decode";
@Injectable({
  providedIn: 'root'
})
export class JwtService {
  private readonly userRole = 'Role';
  private readonly userId = 'UserId';
  private readonly userEmail = 'Email';
  private readonly Name = 'Name';
  private readonly UserType="UserType";
  private readonly ProfileImagePath="ProfileImagePath";
  private readonly EnterpriseId="EnterpriseId";
  private readonly SupplierId="SupplierId";
  private readonly tokenName = 'access_token';
  private readonly userInfoKey = 'UserInfo';
  private readonly tokenInfoKey = 'TokenInfo';

  constructor(private storageService: StorageService) {} // Inject StorageService

  getToken(): string {
    const token = this.storageService.getUserToken();
    return token || '';
  }

  private getUserInfo(): any {
    const decode = this.getDecodedAccessToken();
    if(!decode){
      return null;
    }
    const userInfoJson = decode?.[this.userInfoKey] || {};
    return JSON.parse(userInfoJson);
  }

  private getTokenInfo(): any {
    const decode = this.getDecodedAccessToken();
    const tokenInfoJson = decode?.[this.tokenInfoKey] || {};
    return JSON.parse(tokenInfoJson);
  }

  getDecodedAccessToken(): any {
    const token = this.getToken();
    if (!token) {
      return '';
    }
    const retVal=jwtDecode(token) || null;
    return retVal
  }

  getPermissions(): string {
    const Permission = this.getDecodedAccessToken().Permission;
    return Permission;
  }

  getUserEmail(): string {
    const decode = this.getUserInfo();
    return decode[this.userEmail] || '';
  }

  getUserName(): string {
    const userInfo = this.getUserInfo();
    const fullName = userInfo['Name'] || '';
    return fullName.trim();
  }

  getTokenExpiryTime(isReferesh: boolean): number{
    const tokenInfo = this.getTokenInfo();
    let expiryTime = null;
    if(!isReferesh){
      expiryTime = tokenInfo['RefereshTokenTimeInSeconds'] || 0;
    }
    else{
      expiryTime = tokenInfo['TokenTimeInSeconds'] || 0;
    }
    return Number(expiryTime);
  }

  getUserType(): string {
    const userInfo = this.getUserInfo();
    if(!userInfo){
      return '';
    }
    return userInfo[this.UserType] || '';
  }

  getImagePath(): string {
    const decode = this.getUserInfo();
    return decode[this.ProfileImagePath] || '';
  }

  getEnterPriseId(): string {
    const decode = this.getUserInfo();
    return decode[this.EnterpriseId] || '';
  }
  getSupplierId(): string {
    const decode = this.getUserInfo();
    return decode[this.SupplierId] || '';
  }

  getJobSeekerId(): string {
    const decode = this.getUserInfo();
    const JobSeekerId = decode['JobSeekerId'] || '';
    return JobSeekerId;
  }

  getMobileNumber(): string {
    const decode = this.getUserInfo();
    const mobilePhone = decode['MobilePhone'] || '';
    return mobilePhone;
  }

  getProfileStatus(): string {
    const decode = this.getUserInfo();
    const profileStatus = decode['ProfileStatus'] || '';
    return profileStatus;
  }

  getUserId(): string {
    const decode = this.getUserInfo();
    const userId = decode ==null ?'' : decode['UserId'] || '';
    return userId;
  }
}
